import { createSlice } from "@reduxjs/toolkit";
import { getDashboardDetail } from "./_dashboardAction";

const initialState: any = {
  data: {
    imageSize: '0 MB',
    videoSize: '0 MB',
    totalVideosApproved: 0,
    totalVideosNotApproved: 0,
    totalVideos: 0,
    totalCoach: 0,
    totalStudent: 0,
    totalPlayer: 0,
    totalUsers: 0,
    totalFreeUser: 0,
    totalPageVisited: 0,
  },
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: ''
};

export const dasboardSlice = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getDashboardDetail.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDashboardDetail.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = payload.data || [];
        state.isSuccess = true;
      })
      .addCase(getDashboardDetail.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.errorMessage = payload;
      })
  },
});
